import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");
var Board = require("components/utility/Board");
var ResponseModal = require("components/writing/responses/ResponseModal");
var TeacherViewResponseModal = require("components/writing/responses/TeacherViewResponseModal");

require("reading/shelves/expanded_book_details.scss");

class ExercisesDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { expandedResponse: null };
	}

	expandActivity(activity) {
		// We added a reference to the response onto the activity
		var response = activity.response_reference;
		if (response && response.draft) {
			$wr.redirect("/responses/new?text_id=" + response.text_id + "&activity_id=" + response.activity_id);
		} else {
			this.setState({ expandedResponse: response }, function() {
				this.refs.responseModal.show();
			}.bind(this));
		}
	}
	expandResponse(response) {
		// Two methods because this component is for both teachers and students, which is
		// way more trouble than it's worth
		this.setState({ expandedResponse: response }, function() {
			this.refs.responseModal.show();
		}.bind(this));
	}

	render() {
		if (this.props.book.responses.length == 0 && !this.props.draftsOnly) {
			if (CurrentUser.isStudent()) {
				var exercisesContent = (
					<div className="emptySection">
						Exercises you do about this book go here. <a href="#" onClick={ this.props.startExerciseF }>Start an exercise</a>!
					</div>
				);
			} else {
				var exercisesContent = (
					<div className="emptySection">
						There are no exercises completed for this text.
					</div>
				);
			}

		} else {
			if (CurrentUser.isStudent() && !this.props.draftsOnly) {
				var exerciseLink = (
					<a href="#" className="exerciseLink"
						onClick={ this.props.startExerciseF }>Start Another Exercise</a>					
				)
			}

			if (this.props.draftsOnly) {
				var responsesToDisplay = _.filter(this.props.book.responses, function(response) {
					return response.draft == true;
				})
			} else if (this.props.hideDrafts) {
				var responsesToDisplay = _.filter(this.props.book.responses, function(response) {
					return response.draft == false;
				})
			} else {
				var responsesToDisplay = this.props.book.responses;
			}

			var activities = _.map(responsesToDisplay, function(response) {
				var activityData = _.extend({}, response.activity, { response_reference: response });
				return activityData;
			}.bind(this));

			if (CurrentUser.isStudent()) {
				if (this.state.expandedResponse) {
					var responseModal = (
						<ResponseModal ref="responseModal" key={ this.state.expandedResponse.id }
							responseID={ this.state.expandedResponse.id } user={ CurrentUser.get() } />
					);
				};
				var exercisesContent = (
					<div>
						<Board type={ Board.STUDENT_ACTIVITIES } items={ activities }
							onTileClick={ this.expandActivity } narrowBoard={ true }
							hideAssignAction={ true } />
						{ responseModal }
					</div>
				);
			} else {
				if (this.state.expandedResponse) {
					var responseModal = (
						<TeacherViewResponseModal key={ this.state.expandedResponse.id } ref="responseModal"
							response={ this.state.expandedResponse } student={ this.props.student } />
					);
				}

				var exercisesContent = (
					<div>
						<Board type={ Board.TEACHER_RESPONSES } narrowBoard={ true }
							items={ responsesToDisplay } loading={ false }
							onTileClick={ this.expandResponse } />
						{ responseModal }
					</div>
				);
			}
		}
		return (
			<div className="exercisesContent">
				{ exerciseLink }
				{ exercisesContent }
			</div>
		);
	}
}

ExercisesDisplay.propTypes = StrictPropTypes({
	book: PropTypes.object.isRequired,

	// optional function, for linking to start an exercise in empty state
	startExerciseF: PropTypes.func,
	hideAssignAction: PropTypes.bool,

	// whether to show only drafts / no drafts
	draftsOnly: PropTypes.bool,
	hideDrafts: PropTypes.bool,

	// required for teacher view of exercises
	student: PropTypes.object,
});

module.exports = ExercisesDisplay;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/ExercisesDisplay.js